import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import type { StatefulRoom } from '../../lib/sendbird-calls';
import { demi, normal, small, heavy } from '../../styles/fonts';
import { SuccessMessage } from '../../atoms/Toast';
import { getImageUrl, media } from 'utils';
import { toast } from 'react-toastify';

const RoomIdWrapper = styled.div`
  padding: 0 10px;
`;

export const InfoLabel = styled.label`
  padding: 0 10px;

  ${small};
  ${heavy};
  color: var(--navy-900);
`;

export const InfoInput = styled.div`
  padding: 5px 16px 15px 16px;
  border-radius: 4px;
  margin-top: 6px;
  margin-top: 2px;
  display: flex;
  gap: 30px;
  word-break: break-word;
`;

export const SideInfoInput = styled.div`
  padding: 15px 16px;
  border-radius: 4px;
  margin-top: 6px;
  margin-top: 2px;
  display: flex;
  gap: 30px;
  word-break: break-word;
`;

export const InfoInputText = styled.div`
  ${normal};
  flex-basis: 80%;
  p {
    letter-spacing: -0.1px;
    margin: 0;
  }
`;

export const InfoInputIcon = styled.div`
  width: 30px;
  height: 30px;
  background-image: ${getImageUrl('/icons/ic-copy.svg')};
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;

  ${media.mobile`
    width:20px;
    height:20px;
    background-size:15px;
  `}
`;

export const CopyButton = styled.div`
  ${normal};
  ${demi};
  width: 80px;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  border-radius: 4px;
  background-color: var(--purple-300);
  cursor: pointer;
`;

export const InputWithCopyButton = ({ text, title }: { text: string; title: string }) => {
  return (
    <RoomIdWrapper>
      <InfoLabel>{title}</InfoLabel>
      <SideInfoInput>
        <InfoInputText>
          <p>{text}</p>
        </InfoInputText>
        <CopyButton
          onClick={() => {
            copy(text);
            toast(<SuccessMessage message={'Room url copied.'} />, { autoClose: 2000 });
          }}
        >
          Copy
        </CopyButton>
      </SideInfoInput>
    </RoomIdWrapper>
  );
};

export const InputWithCopyIcon = ({
  title,
  text,
  icon = true,
}: {
  title?: string;
  text: string;
  icon?: boolean;
}) => {
  return (
    <RoomIdWrapper>
      <InfoLabel>{title}</InfoLabel>
      <InfoInput>
        <InfoInputText>{text}</InfoInputText>
        {icon && (
          <InfoInputIcon
            onClick={() => {
              copy(text);
              toast(<SuccessMessage message={'Room ID copied.'} />, { autoClose: 2000 });
            }}
          />
        )}
      </InfoInput>
    </RoomIdWrapper>
  );
};

const RoomCreatorWrapper = styled.div``;
export const RoomCreatorInfo = ({ room }: { room: StatefulRoom }) => {
  return (
    <RoomCreatorWrapper>
      <label>Created by</label>
      <div>
        <img src={room.createdBy} />
      </div>
    </RoomCreatorWrapper>
  );
};
